import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { useNavigate } from 'react-router-dom';
import { SearchWord, Results, PageWrapper } from './style';
import routes from '../../../routes';
import { NoResult, Text } from '../../../ui/atoms';
import {
  SEARCH_COURSES_LIST_GET,
  SEARCH_DOCUMENTS_LIST_GET,
  SEARCH_EVENTS_LIST_GET,
  SEARCH_MODULES_LIST_GET,
} from '../../redux/actions/search';
import { COURSE_CATEGORIES_GET } from '../../redux/actions/courselist';
import { Container } from '../../../ui/gridSystem';
import Tabs from '../../../ui/atoms/Tabs';
import CourseResults from './CourseResults';
import DocumentsResults from './DocumentResults';
import { DOCUMENTS_CATEGORIES_GET } from '../../redux/actions/documents';
import ModalLeaveCourse from '../../../ui/atoms/Modals/ModalLeaveCourse';
import ModalSurvey from '../../../ui/atoms/Modals/ModalSurvey';
import ModuleResults from './ModuleResults';
import EventResults from './EventResults';
import { useResetSearchWord } from '../../../utils/highlight';

const defaultTabs = [
  { value: 'courses', label: 'Corsi' },
  { value: 'modules', label: 'Moduli' },
  { value: 'events', label: 'Eventi' },
  { value: 'documents', label: 'Documenti' },
];

const Search = ({
  getCourses,
  getModules,
  getEvents,
  getDocuments,
  search_word,
  coursePager,
  modulePager,
  eventPager,
  docPager,
  getCategories,
  getDocumentCategories,
}) => {
  const navigate = useNavigate();
  const resetSearchWord = useResetSearchWord();
  const [tabs, setTabs] = useState(defaultTabs);
  const [activeTab, setActiveTab] = useState(defaultTabs[0]);

  useEffect(() => {
    if (search_word.length <= 0) {
      navigate(routes.home.path);
    } else {
      window.scrollTo(0, 0);
      getCategories();
      getDocumentCategories();
      getCourses(search_word);
      getModules(search_word);
      getEvents(search_word);
      getDocuments(search_word);
    }
    return () => {
      // reset searchWord if not going to Course or DocumentDetails or search another word
      if (
        !(
          window.location.href.includes(routes.courseDetails.path) ||
          window.location.href.includes(routes.documentDetails.path) ||
          window.location.href.includes(routes.search.path)
        )
      ) {
        resetSearchWord();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search_word]);

  useEffect(() => {
    const newTabs = [...defaultTabs];
    newTabs[0].items = coursePager?.total_items ?? 0;
    newTabs[1].items = modulePager?.total_items ?? 0;
    newTabs[2].items = eventPager?.total_items ?? 0;
    newTabs[3].items = docPager?.total_items ?? 0;
    setTabs(newTabs);
  }, [
    coursePager.total_items,
    docPager.total_items,
    eventPager?.total_items,
    modulePager.total_items,
  ]);

  const getPageResults = ({ items_per_page, page, total_items }) => {
    if (!items_per_page || !total_items) return '';
    return `${1 + page * items_per_page} - ${Math.min(
      items_per_page * (page + 1),
      total_items
    )} dei ${total_items} risultati in`;
  };

  return (
    <>
      <Container>
        <Text type="h1" mb={8}>
          Risultati di ricerca
        </Text>
        <Results>
          {activeTab?.value === 'courses'
            ? getPageResults(coursePager)
            : activeTab?.value === 'modules'
            ? getPageResults(modulePager)
            : activeTab?.value === 'events'
            ? getPageResults(eventPager)
            : activeTab?.value === 'documents'
            ? getPageResults(docPager)
            : 'Risultati per'}
          <SearchWord> "{search_word}"</SearchWord>
        </Results>
        {/* TABS */}
        <Tabs
          tabs={tabs}
          selected={activeTab}
          onChange={(tab) => {
            setActiveTab(tab);
          }}
        />
        <PageWrapper className={activeTab?.value === 'courses' ? 'active' : ''}>
          <CourseResults active={activeTab?.value === 'courses'} />
        </PageWrapper>
        <PageWrapper className={activeTab?.value === 'modules' ? 'active' : ''}>
          <ModuleResults active={activeTab?.value === 'modules'} />
        </PageWrapper>
        <PageWrapper className={activeTab?.value === 'events' ? 'active' : ''}>
          <EventResults active={activeTab?.value === 'events'} />
        </PageWrapper>
        <PageWrapper
          className={activeTab?.value === 'documents' ? 'active' : ''}
        >
          <DocumentsResults active={activeTab?.value === 'documents'} />
        </PageWrapper>
        {!activeTab && <NoResult />}
      </Container>
      <ModalLeaveCourse />
      <ModalSurvey />
    </>
  );
};

Search.propTypes = {
  // HOC (connect, state)
  search_word: PropTypes.string,
  coursePager: PropTypes.object,
  modulePager: PropTypes.object,
  eventPager: PropTypes.object,
  docPager: PropTypes.object,
  //HOC (connect, dispatch)
  getCourses: PropTypes.func.isRequired,
  getModules: PropTypes.func.isRequired,
  getEvents: PropTypes.func.isRequired,
  getCategories: PropTypes.func.isRequired,
  getDocuments: PropTypes.func.isRequired,
  getDocumentCategories: PropTypes.func.isRequired,
};

export default connect(
  (state) => {
    const {
      search_word,
      courses: { pager: coursePager },
      modules: { pager: modulePager },
      documents: { pager: docPager },
      events: { pager: eventPager },
    } = state.search;
    return {
      search_word,
      coursePager,
      modulePager,
      eventPager,
      docPager,
    };
  },
  (dispatch) => ({
    getCourses: (title) =>
      dispatch({
        type: SEARCH_COURSES_LIST_GET._REQUEST,
        title,
        filters: { typology: 'course' },
      }),
    getModules: (title) =>
      dispatch({ type: SEARCH_MODULES_LIST_GET._REQUEST, title }),
    getEvents: (title) =>
      dispatch({ type: SEARCH_EVENTS_LIST_GET._REQUEST, title }),
    getDocuments: (title) =>
      dispatch({ type: SEARCH_DOCUMENTS_LIST_GET._REQUEST, title }),
    getCategories: () => dispatch({ type: COURSE_CATEGORIES_GET._REQUEST }),
    getDocumentCategories: () =>
      dispatch({ type: DOCUMENTS_CATEGORIES_GET._REQUEST }),
  })
)(Search);
